export const labelSx = {
  fontWeight: 600,
  fontSize: 14,
  color: "primary.main",
  lineHeight: "20px",
};

export const hintSx = {
  fontSize: 12,
  color: "rgba(1,67,57,0.6)",
  lineHeight: "16px",
};

export const inputSx = {
  borderRadius: "10px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(1,67,57,0.2)",
    borderWidth: 2,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "primary.main",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "primary.main",
  },
};

export const switchSx = {
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#014339",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#014339",
  },
};

export const radioCardSx = (selected: boolean) => ({
  flex: 1,
  border: "2px solid",
  borderColor: selected ? "primary.main" : "rgba(1,67,57,0.15)",
  borderRadius: "10px",
  px: 1.5,
  py: 1,
  cursor: "pointer",
  backgroundColor: selected ? "rgba(1,67,57,0.03)" : "white",
  transition: "all 0.15s",
  "&:hover": { borderColor: "primary.main" },
});

export const radioCardRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const radioCircleOuterSx = (selected: boolean) => ({
  width: 16,
  height: 16,
  borderRadius: "50%",
  border: "2px solid",
  borderColor: selected ? "primary.main" : "rgba(1,67,57,0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export const radioCircleInnerSx = {
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: "primary.main",
};

export const radioCardLabelSx = {
  fontWeight: 600,
  fontSize: 13,
  color: "primary.main",
};

export const REPITCHING_DESCRIPTION =
  "Automatically pitch another contact at the same brand when available if there’s no reply within 2 weeks. This helps maximize your pitching from this automation.";
